import { saveAs } from 'file-saver';
import { events } from './events';
import { Module } from './framework/module';
import { Recorder } from './recorder';

export class RecorderModule extends Module {
  constructor() {
    super({});
  }

  async onInit() {
    let recorder = new Recorder();

    events.on('select-source', () => recorder.selectSource());
    events.on('start-recording', () => recorder.startRecording());
    events.on('stop-recording', () => recorder.stopRecording());
    events.on('recording-finished', ({ recording, type }) => {
      const now = new Date();
      saveAs(
        recording,
        `screencorder.io-${now.getFullYear()}-${now
          .getMonth()
          .toString()
          .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}T${now
          .getHours()
          .toString()
          .padStart(2, '0')}.${now
          .getMinutes()
          .toString()
          .padStart(2, '0')}.${now
          .getSeconds()
          .toString()
          .padStart(2, '0')}.${type}`
      );
    });
  }
}
